import * as tslib_1 from "tslib";
import { OnInit, TemplateRef } from '@angular/core';
import { NavigationService } from 'src/app/services/navigation.service';
import { CapacitacionService } from 'src/app/services/capacitacion.service';
import { EventYearCalendarService } from 'src/app/services/event-yearCalendar.service';
import { EventEmitterService } from 'src/app/services/event-emitter.service';
//Borrar en caso de error
import { startOfDay, isSameDay, isSameMonth, } from 'date-fns';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CalendarEvent, CalendarEventTimesChangedEvent, CalendarView, } from 'angular-calendar';
import { CategoryService } from "../../../services/category.service";
import { EnfoqueService } from "../../../services/enfoque.service";
import { EjecutorService } from "../../../services/ejecutor.service";
import { ZoneService } from "../../../services/zone.service";
import { LoginService } from 'src/app/services/login.service';
const colors = {
    red: {
        primary: '#ad2121',
        secondary: '#FAE3E3',
    },
    blue: {
        primary: '#1e90ff',
        secondary: '#D1E8FF',
    },
    yellow: {
        primary: '#e3bc08',
        secondary: '#FDF1BA',
    },
    green: {
        primary: '#25e308',
        secondary: '#c7fdba',
    },
};
export class CalendarViewComponent {
    constructor(navigationService, capacitacionService, eventYearCalendarService, eventEmitterService, modalService, categoryService, enfoqueService, ejecutorService, zoneService, modal, loginService) {
        this.navigationService = navigationService;
        this.capacitacionService = capacitacionService;
        this.eventYearCalendarService = eventYearCalendarService;
        this.eventEmitterService = eventEmitterService;
        this.modalService = modalService;
        this.categoryService = categoryService;
        this.enfoqueService = enfoqueService;
        this.ejecutorService = ejecutorService;
        this.zoneService = zoneService;
        this.modal = modal;
        this.loginService = loginService;
        this.view = CalendarView.Month;
        this.CalendarView = CalendarView;
        this.viewDate = new Date();
        this.locale = 'es';
        this.workersSelected = [];
        this.loading = false;
        this.listStatus = [];
        this.calendario = [];
        this.refresh = new Subject();
        this.activeDayIsOpen = false;
        this.eventEmitterService.invokeCalendarRefresh.subscribe({
            next: (event) => {
                console.log(`Received message`);
                this.getCapacitacionesCalendario();
            }
        });
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.loginService.obtenerPermisosMenu('planificacion').then((response) => {
                this.rolid = response.data.rolId;
            });
            $("#show-loading").css('display', 'grid');
            this.getCapacitacionesCalendario();
        });
    }
    ngOnDestroy() {
    }
    getCapacitacionesCalendario() {
        $("#show-loading").css('display', 'grid');
        this.events = [];
        this.calendario = [];
        this.activeDayIsOpen = false;
        this.refresh.next();
        this.capacitacionService.getCapacitacionesCalendario(parseInt(sessionStorage.getItem('userid')), parseInt(this.rolid))
            .then(response => {
            for (let o of response) {
                let categoriaId = "";
                let titulo = "";
                if (this.rolid == 1 || this.rolid == 2) {
                    categoriaId = o.categoryId;
                    titulo = o.capacitacionTypeDescription + ": " + o.name + "(Plan Asociado : " + o.planCapacitacion + ") Estado : " + o.stateShortDescription;
                }
                else {
                    categoriaId = o.categoryId;
                    titulo = o.capacitacionTypeDescription + ": " + o.name + " Estado : " + o.stateShortDescription;
                }
                let fecha = o.fecha.split("-");
                let currentTime = new Date();
                let month = currentTime.getMonth() + 1;
                let year = currentTime.getFullYear();
                let fechaActual = new Date(year, month);
                let fechaCapacitacion = new Date(fecha[2], fecha[1]);
                let estado = 1;
                if (o.stateId == 5 || o.stateId == 7 || o.stateId == 8) {
                    estado = 2;
                }
                let array = {
                    id: categoriaId,
                    start: startOfDay(new Date(fecha[2], fecha[1] - 1, fecha[0])),
                    title: titulo,
                    color: estado == 1 ? colors.red : (estado == 2) ? colors.green : colors.blue,
                    month: fecha[1],
                    statusCapacitacion: o.stateShortDescription
                };
                this.calendario.push(array);
            }
            this.events = this.calendario;
            this.refresh.next();
            $("#show-loading").css('display', 'none');
        })
            .catch(error => {
            $("#show-loading").css('display', 'none');
            error = true;
        });
    }
    changeView(viewdate) {
        this.viewDate = viewdate;
    }
    getEjecutores() {
        return new Promise((resolve, reject) => {
            this.ejecutorService.listWithRelatores()
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    getZonas() {
        return new Promise((resolve, reject) => {
            this.zoneService.getZonas()
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    getAsistentes(capacitacionId) {
        return new Promise((resolve, reject) => {
            this.capacitacionService.getAsistentes(capacitacionId)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    getEnfoques(id) {
        this.enfoqueService.enfoqueById(id)
            .then(response => {
            let resp = response;
            this.listStatus = resp;
        })
            .catch(error => {
            error = true;
        });
        return new Promise((resolve, reject) => {
            this.enfoqueService.enfoqueById(id)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    getCategories(id) {
        this.categoryService.getByIdCategorias(id)
            .then(response => {
            let resp = response;
            this.listStatus = resp;
        })
            .catch(error => {
            error = true;
        });
        return new Promise((resolve, reject) => {
            this.categoryService.getByIdCategorias(id)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    getCategoriesAll() {
        return new Promise((resolve, reject) => {
            this.categoryService.listWithFocos()
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    getEnfoquesAll() {
        return new Promise((resolve, reject) => {
            this.enfoqueService.list()
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    onSave() {
        this.getCapacitacionesCalendario();
        this.eventEmitterService.onFirstComponentButtonClick();
        this.eventEmitterService.onIndicatorsRefresh();
    }
    onSaveAccept() {
        this.getCapacitacionesCalendario();
        this.eventEmitterService.onFirstComponentButtonClick();
        this.eventEmitterService.onIndicatorsRefresh();
    }
    openModal(modal, mode, event) {
        this.loading = true;
        console.log('Evento desde el calendario');
        console.log(event);
        $("#show-loading").css('display', 'grid');
        this.getCapacitacion(Number(event.id), event.statusCapacitacion);
        const modalOptions = { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' };
        // Promise.all([
        //   this.getCategories(id),
        //   this.getEnfoques(id),
        //   this.getEjecutores(),
        //   this.getZonas(),
        // ])
        Promise.all([
            this.getCategoriesAll(),
            this.getEnfoquesAll(),
            this.getEjecutores(),
            this.getZonas(),
            this.getAsistentes(event.id)
        ])
            .then(results => {
            this.categoriesWithFocos = results[0];
            this.enfoques = results[1];
            this.ejecutoresWithRelatores = results[2];
            this.zonas = results[3];
            this.workersSelected = results[4];
            this.creationMode = mode;
            this.loading = false;
            $("#show-loading").css('display', 'none');
            this.modalService.open(modal, modalOptions);
        })
            .catch(error => {
            console.error(error);
            $("#show-loading").css('display', 'none');
        });
    }
    getCapacitacion(id, statusCapacitacion) {
        this.capacitacionService.getCapacitacion(id)
            .then(response => {
            this.datosCapacitacion = response;
            this.datosCapacitacion.statusCapacitacionLabel = statusCapacitacion;
        })
            .catch(error => {
            console.error(error);
        });
    }
    dayClicked({ date, events }) {
        if (isSameMonth(date, this.viewDate)) {
            if ((isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
                events.length === 0) {
                this.activeDayIsOpen = false;
            }
            else {
                this.cantidadCapacitaciones = events.length;
                this.activeDayIsOpen = true;
            }
            this.viewDate = date;
        }
    }
    eventTimesChanged({ event, newStart, newEnd, }) {
        this.events = this.events.map((iEvent) => {
            if (iEvent === event) {
                return Object.assign({}, event, { start: newStart, end: newEnd });
            }
            return iEvent;
        });
        this.handleEvent('Dropped or resized', event);
    }
    handleEvent(action, event) {
        this.modalData = { event, action };
        this.modal.open(this.modalContent, { size: 'lg' });
    }
    setView(view) {
        this.view = view;
    }
    closeOpenMonthViewDay() {
        this.activeDayIsOpen = false;
    }
}
